import { render, staticRenderFns } from "./OverflowMenu.vue?vue&type=template&id=6a7915d9&scoped=true"
import script from "./OverflowMenu.vue?vue&type=script&lang=js"
export * from "./OverflowMenu.vue?vue&type=script&lang=js"
import style0 from "./OverflowMenu.vue?vue&type=style&index=0&id=6a7915d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7915d9",
  null
  
)

export default component.exports